/**
 * Cabeçalho por cima da abertura.
 *
 * Publica a altura real do cabeçalho em `--alt-head` e tira-lhe o fundo
 * enquanto a abertura estiver visível. A altura é medida porque muda com a
 * fita de avisos, com o número de categorias e com a largura do ecrã.
 */
const cabecalho = document.querySelector('.claro-head');
const capa = document.querySelector('[data-claro-capa]');

if (cabecalho && capa) {
  const medir = () =>
    document.documentElement.style.setProperty('--alt-head', `${cabecalho.offsetHeight}px`);

  const pintar = () =>
    cabecalho.classList.toggle('claro-head--sobre', scrollY < capa.offsetHeight - cabecalho.offsetHeight);

  medir();
  pintar();

  addEventListener('resize', () => {
    medir();
    pintar();
  });
  addEventListener('scroll', pintar, { passive: true });

  // O editor de temas troca secções sem recarregar a página
  document.addEventListener('shopify:section:load', () => {
    medir();
    pintar();
  });
}
